import cx from 'classnames';
import type { FunctionComponent } from 'react';

import SuccessIcon from '@atlaskit/icon/core/success';
import { Button } from '@trello/nachos/button';
import type { CardTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';
import { token } from '@trello/theme';

import type { CardDoneStateProps } from './CardDoneState';

// eslint-disable-next-line @trello/less-matches-component
import styles from './CardDoneState.less';

interface CardDoneStateReadOnlyProps {
  isComplete?: boolean;
}
export const CardDoneStateReadOnly: FunctionComponent<
  CardDoneStateProps & CardDoneStateReadOnlyProps
> = ({
  children,
  buttonClassName,
  containerClassName,
  isComplete,
  readOnlyCustomIcon,
}) => {
  return (
    <div
      data-testid={getTestId<CardTestIds>('card-done-state-read-only')}
      className={cx(containerClassName, styles.cardDoneState)}
    >
      {isComplete && (
        <Button
          className={cx(buttonClassName, {
            [styles.checkmarkButton]: true,
          })}
          appearance="subtle"
          isDisabled={true}
        >
          <SuccessIcon
            label="complete" // TODO: Add translations
            color={token('color.icon.success', '#4bce97')}
          />
        </Button>
      )}

      {!isComplete && readOnlyCustomIcon && <>{readOnlyCustomIcon}</>}

      {children && (
        <span
          className={cx({
            [styles.cardTitle]: true,
            [styles.isComplete]: isComplete,
          })}
        >
          {children}
        </span>
      )}
    </div>
  );
};
